'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var trim = function trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

exports.default = trim;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-select/lib/utils/trim.js
 ** module id = 1004
 ** module chunks = 2 3 4 5 6 11 13 16 18 24 25 35 36 38 39 51 52 54 55 56 57 59 62
 **/